<template>
    <div>
        <!--<section class="is-relative section">-->
        <div class="lb-question-games">
            <div class="map-container info-windows">
                <google-map
                    id="map"
                    ref="Map"
                    :zoom="zoom"
                    :center="center"
                    :options="{
                    fullscreenControl: false,
                    mapTypeControl: true,
                    mapTypeControlOptions: {
                        position: 3,
                    },
                    streetViewControl: false,
                    minZoom: 2,
                    maxZoom: 20,
                }"
                >
                    <google-map-marker
                        v-for="(infoWindow, index) in itemsWithLocation"
                        :title="infoWindow.title"
                        :position="infoWindow.location | convertLatLng"
                        :key="index"
                        :icon="'/img/icons/poi.png'"
                        @click="openQuestion(infoWindow)"
                        @mouseover="toggleInfoWindow(infoWindow)"
                        @mouseout="showInfo = false"
                    />
                    <google-map-marker
                        v-for="(infoWindow, index) in itemsOpened"
                        :title="infoWindow.title"
                        :position="infoWindow.location | convertLatLng"
                        :key="'sel'+index"
                        :icon="'/img/icons/poiSel.png'"
                        @click="openQuestion(infoWindow)"
                        @mouseover="toggleInfoWindow(infoWindow)"
                        @mouseout="showInfo = false"
                    />
                    <google-map-marker
                        v-for="(infoWindow, index) in itemsSolved"
                        :title="infoWindow.title"
                        :position="infoWindow.location | convertLatLng"
                        :key="'solv'+index"
                        :icon="'/img/icons/poiSolv.png'"
                        @mouseover="toggleInfoWindow(infoWindow)"
                        @mouseout="showInfo = false"
                    />
                    <google-map-infowindow
                        :position="infoWindowContext.position"
                        :show.sync="showInfo"
                        :options="{ maxWidth: 300, pixelOffset: offset }"
                    >
                        <p>{{ infoWindowContext.title }}</p>
                    </google-map-infowindow>
                </google-map>
                <div v-if="showQuestion" class="lb-question-container pt-6">
                    <session-object-card
                        ref="questionCard"
                        :key="question._id"
                        :time-limit="0"
                        :time-units="session.configuration.timeUnits"
                        :content="question"
                        :is-simulation="session.simulation"
                        :show-map="false"
                        :closeable="true"
                        @answer="registerAnswer"
                        @timeout="registerEmptyAnswer"
                        @stopSimulation="showQuestion=false"
                    >
                        <nav class="level is-mobile">
                            <div class="level-left"></div>
                            <div class="level-item">
                                <progress
                                    :value="progress"
                                    class="progress is-primary px-3"
                                    max="100"
                                >{{ progress }}%</progress>
                            </div>
                            <div class="level-right">
                                <a
                                    class="button has-background-very-light-pink"
                                    @click="registerEmptyAnswer"
                                >
                                    <span class="icon is-medium">
                                        <i class="mdi mdi-24px mdi-chevron-right"></i>
                                    </span>
                                </a>
                            </div>
                        </nav>
                    </session-object-card>
                    <app-animation v-if="showAnimation" :animation="animation" />
                </div>
                <play-score-viewer
                    v-if="!session.simulation && questions.length"
                    :score="score"
                    :ranking="rankingInfo"
                    :questions="questionsInfo"
                    class="lb-score-play"
                />
                <session-end-resume
                    v-if="!questions.length"
                    :score="score"
                    :rightQuestions="rightQuestions"
                    :failedQuestions="failedQuestions"
                    :noAnswered="noAnswered"
                    class="resume"
                />
            </div>
        </div>
        <!-- </section>-->
    </div>
</template>

<script>
import SessionObjectCard from '@/components/SessionObjectCard';
import SessionEndResume from '@/components/SessionEndResume';
import AppAnimation from '@/components/AppAnimation';
import PlayScoreViewer from '@/components/PlayScoreViewer';
import { sendAnswer, getUserRankingPosition } from '@/services/API';
import _ from 'underscore';
import MapboxToGoogleMaps from '@/mixins/MapboxToGoogleMaps';
export default {
    components: {
        SessionObjectCard,
        AppAnimation,
        PlayScoreViewer,
        SessionEndResume,
    },
    mixins: [MapboxToGoogleMaps],
    data() {
        return {
            index: 0,
            showAnimation: false,
            animation: require('@/assets/animations/checkmark.json'),
            currentSessionAnsweredQuestions: [],
            score: 0,
            rightQuestions: 0,
            noAnswered: 0,
            map: undefined,
            showInfo: false,
            infoWindowContext: {
                title: 'a title',
                id: 'a id',
                description: 'a description',
                position: {
                    lat: 44.2899,
                    lng: 11.8774,
                },
            },
            defaultZoom: 6,
            center: { lat: 40, lng: -2 },
            showQuestion: false,
            question:{},
            rankingInfo:{
                position: 0,
                users: 0
            },
            itemsOpened: [],
            itemsSolved: [],
        };
    },
    computed: {
        answeredQuestions() {
            return [
                ...this.currentSessionAnsweredQuestions,
                ..._.pluck(
                    _.pluck(this.session.session_answers, 'object'),
                    '_id'
                ),
            ];
        },
        questions() {
            const remainingQuestions = _.chain(this.session.context)
                .filter((question) => {
                    return !_.contains(this.answeredQuestions, question._id);
                })
                .sort((question) => {
                    return -new Date(question.created);
                })
                .value();
            if (remainingQuestions.length == 0) {
                this.$emit('close');
            }
            return remainingQuestions;
        },
        session() {
            return this.$store.state.session;
        },
        progress() {
            return (
                (
                    this.answeredQuestions.length / this.session.context.length
                ).toFixed(2) * 100
            );
        },
        failedQuestions(){
            return this.session.context.length - this.rightQuestions - this.noAnswered;
        },
        items(){
            return this.session.context;
        },
        itemsWithLocation() {
            return _.chain(this.questions)
                .filter((item) => {
                    if (!item.title.length && _.isObject(item.location)) {
                        item.title = this.$t('Constants.TITLE_NEEDED');
                    }
                    return _.isObject(item.location);
                })
                .value();
        },
        bounds() {
            const bounds = new window.google.maps.LatLngBounds();
            _.each(this.itemsWithLocation, (item) => {
                bounds.extend(
                    new window.google.maps.LatLng(
                        MapboxToGoogleMaps.filters.convertLatLng(item.location)
                    )
                );
            });
            return bounds;
        },
        zoom() {
            return this.defaultZoom;
        },
        offset() {
            return new window.google.maps.Size(0, -42);
        },
        questionsInfo() {
            return {
                'answered':this.answeredQuestions.length,
                'total':this.items.length
            }
        },
    },
    watch: {
        items: {
            immediate: true,
            handler() {
                if (this.items && this.items.length) {
                    setTimeout(() => {
                    this.$refs.Map.fitBounds(this.bounds);
                    }, "1000")
                    
                }
            },
            deep: true
        },
    },
    mounted() {
        if (!this.session.simulation) {
            // no need to get user score in simulated session
            getUserRankingPosition(this.session._id).then(({ data }) => {
                this.rankingInfo.users = data.totalUsers;
                this.rankingInfo.position = data.totalUsers;
                this.score = data.score;
            });
        }
        navigator.geolocation.getCurrentPosition((pos) => {
            this.center = {
                lat: pos.coords.latitude,
                lng: pos.coords.longitude,
            };
        });
        
        
    },
    methods: {
        registerEmptyAnswer() {
            this.registerAnswer({
                answer: {
                    answer: { value: '' },
                    object: this.question._id,
                    time: 0,
                    points: 0,
                },
            });
            this.noAnswered++;
            setTimeout(() => {
                this.showQuestion=false;
                const elementIndex = _.findIndex(this.itemsOpened, {
                    _id: this.question._id,
                });
                this.itemsOpened.splice(elementIndex, 1);
            
            }, "2000")
        },
        async registerAnswer({ answer }) {
            //this.$emit("answer", answer);
            this.showAnimation = true;
            if (answer.points > 0) {
                this.animation = require('@/assets/animations/checkmark.json');
                this.rightQuestions++;
            } else {
                this.animation = require('@/assets/animations/error.json');
            }
            setTimeout(() => {
                this.showAnimation = false;
                this.currentSessionAnsweredQuestions.push(answer.object);
            }, 2000);

            if (this.session.simulation) {
                return;
            }

            await sendAnswer(this.$store.state.session._id, {
                ...answer,
                project: this.$store.state.session.project,
            });
            let position = await getUserRankingPosition(this.session._id);
            this.rankingInfo.users = position.data.totalUsers;
            this.rankingInfo.position = position.data.position +1;

            this.score = position.data.score;
            setTimeout(() => {
                
                const elementIndex = _.findIndex(this.itemsOpened, {
                    _id: this.question._id,
                });
                this.itemsOpened.splice(elementIndex, 1);
                this.itemsSolved.push(this.question);
                this.showQuestion=false;
            }, "2000")
            
        },
        
        toggleInfoWindow(context) {
            this.infoWindowContext = {
                title: context.title,
                _id: context._id,
                position: {
                    lat: context.location.latitude,
                    lng: context.location.longitude,
                },
            };
            this.showInfo = true;
        },
        openQuestion(element){
            console.log("opening",element._id)
            this.question = element;
            this.showQuestion = true;
            if (!_.contains(this.itemsOpened, element)) {
                this.itemsOpened.push(element);
                
            }
            console.log("items opened",this.itemsOpened)

        }
    },
};
</script>

<style scoped>
@import '~vuejs-google-maps/dist/vuejs-google-maps.css';
.map-container {
    position: relative;
    height: calc(100vh - 3.2rem) !important;
}
/deep/.gm-style button,
/deep/.gm-style ul > li {
    font-size: 14px !important;
}
/deep/.gm-style {
    font-family: 'Open sans', sans-serif;
}
/deep/button.gm-ui-hover-effect {
    visibility: hidden;
}

.lb-question-games {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    margin: auto;
}
.lb-game-card {
    width: 38rem;
    position: absolute;
    top: 5rem;
    left: 0;
    margin: auto;
    right: 0;
    max-height: 90%;
    overflow-y: auto;
}
.lb-score-play {
    position: absolute !important;
    margin: auto;
    top: 2rem;
    left: 0;
    right: 0;
}
.progress {
    border-radius: 0;
    height: 0.4rem;
}
.resume {
    position: absolute;
    top: 4rem;
    left: 0;
    right: 0;
}
</style>